import { render, staticRenderFns } from "./MitarbeiterAuskunft.vue?vue&type=template&id=4048b656&scoped=true&"
import script from "./MitarbeiterAuskunft.vue?vue&type=script&lang=js&"
export * from "./MitarbeiterAuskunft.vue?vue&type=script&lang=js&"
import style0 from "./MitarbeiterAuskunft.vue?vue&type=style&index=0&id=4048b656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048b656",
  null
  
)

export default component.exports